import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SupportService } from 'apps/app-cic-ciam/src/services/support.service';
import { ToastrService } from 'ngx-toastr';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { TranslateService } from '@ngx-translate/core';
import { phoneNumberWrapping } from '../../functions/utils';
import { FactorInfoChange, SmsEnrollResponse } from '../../app.actions';
import { SelfFactorService } from 'apps/app-cic-ciam/src/services/selffactor.service';

@Component({
    selector: 'ciciam-phone-change-popup',
    templateUrl: './phone-change-popup.component.html',
    styleUrls: ['./phone-change-popup.component.scss']
})
export class PhoneChangePopupComponent {
  showModal = false;

  courseId: string = '';
  courseName: string = '';
  coursePrice: number = 0;
  onSuccess?: () => Promise<any> = undefined;
  @Select(STATE_TOKEN) appState$!: Observable<StateModel>;
  // userId?: string;
  isLoading: boolean = false;

  phoneForm: FormGroup = this.fb.group({
    phoneNumber: ['', [Validators.required, Validators.pattern('^(\\+[0-9]+|[0-9]{8})$')]],
  });

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private supportService: SupportService,
    private selfFactorService: SelfFactorService,
    private translate: TranslateService,
    private store: Store
  ) {}

  ngOnInit(): void {
    // this.appState$.subscribe((state) => {
    //   this.userId = state.userId;
    // });
  }

  requestPrompt(onSuccess?: () => Promise<any>) {
    this.onSuccess = onSuccess;
    this.showModal = true;
    this.phoneForm.reset();
  }

  onResult = async ($event: any) => {
    this.toastr.success(this.translate.instant('SMS Authentication updated successfully'), this.translate.instant('Success'));
    this.toggleModal();
    this.onSuccess?.();
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  useStripe() {
    this.toggleModal();
  }

  onCancel($event: any) {
    $event.preventDefault();
    this.toggleModal();
  }

  async onPhoneFormSubmit() {
    this.phoneForm.markAllAsTouched();
    if(this.phoneForm.valid) {
      this.isLoading = true;
      try {
        let result = await this.selfFactorService.selfSend2faSms(true, phoneNumberWrapping(this.phoneForm.value.phoneNumber));
        if(!result || result.success == false) {
          this.phoneForm.controls['phoneNumber'].setErrors({ 'phoneused': 'phoneused' });
          this.isLoading = false;
        } else {
          this.toastr.success(this.translate.instant('Phone number updated successfully'), this.translate.instant('Success'));
          this.store.dispatch(new SmsEnrollResponse(result));
          this.store.dispatch(new FactorInfoChange(phoneNumberWrapping(this.phoneForm.value.phoneNumber)));
          this.isLoading = false;
          this.toggleModal();
          this.onSuccess?.();
        }
      } catch(e) {
        this.toastr.error(this.translate.instant('Failed to update phone number'), this.translate.instant('Error'));
        this.isLoading = false;
      }
    }
  }
}
